import { render, staticRenderFns } from "./the-main-nav.vue?vue&type=template&id=33634bb2&scoped=true&"
import script from "./the-main-nav.vue?vue&type=script&lang=js&"
export * from "./the-main-nav.vue?vue&type=script&lang=js&"
import style0 from "./the-main-nav.vue?vue&type=style&index=0&id=33634bb2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33634bb2",
  null
  
)

export default component.exports